import { composeWithDevTools } from '@redux-devtools/extension';
import Immutable from 'immutable';
import merge from 'lodash/merge';
import { compose } from 'redux';

import * as DebugSettingsUtil from '../../lib/configuration/DebugSettingsUtil';

export const reduxDevToolsConfigs = merge(
  {
    serialize: {
      immutable: Immutable,
    },
  },
  DebugSettingsUtil.getReduxDevtoolOptions(),
);

/**
 * Wrapper around Redux compose to optionally return uplifted REDUX_DEVTOOLS compose
 */
export default DebugSettingsUtil.isReduxDevtoolEnabled()
  ? composeWithDevTools(reduxDevToolsConfigs)
  : compose;
